module.exports = __webpack_public_path__ + "static/media/export-csv-dafault.dc860887.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/export-csv-dafault.svg
// module id = 1612
// module chunks = 1